<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item">Administración</li>
  <li class="breadcrumb-item active">Periodos</li>
</ol>

<h1 class="page-header"><i class="fas fa-calendar-check"></i> Periodos<small> Apertura y cierre de {{module?.name || (routeSegment || 'evaluación')}}</small></h1>

<div class="scrollable">
  @if(!module) {
  <div class="alert alert-warning">
    <i class="fas fa-triangle-exclamation"></i>
    No se encontró un módulo activo para la ruta <b>"{{routeSegment}}"</b>.
    @if(availableRoutes.length > 0) {
    Rutas disponibles: <b>{{availableRoutes.join(', ')}}</b>.
    } @else {
    El sistema no devolvió módulos activos.
    }
    Verifica que el ítem de menú tenga asignado el módulo y que la URL sea <b>/:route/periodos</b>.
  </div>
  }
  <panel title="Selección de periodo" [noButton]="true">
    @if(module && groups.length === 0) {
    <div class="alert alert-info mb-3">
      <i class="fas fa-circle-info"></i>
      Este módulo no tiene grupos configurados. Asígnelos en <b>Administración → Módulos</b>.
    </div>
    }
    <div class="row">
      <div class="col-md-4">
        Grupo
        <ng-select [items]="groups" bindLabel="name" [(ngModel)]="selectedGroup" [clearable]="false" (ngModelChange)="onFilterChange()"></ng-select>
      </div>
      <div class="col-md-4">
        Año
        <ng-select [items]="years" [(ngModel)]="yearSelected" [clearable]="false" (ngModelChange)="onFilterChange()"></ng-select>
      </div>
      <div class="col-md-4">
        Mes
        <ng-select [items]="months" bindLabel="name" bindValue="value" [(ngModel)]="monthSelected" [clearable]="false" (ngModelChange)="onFilterChange()"></ng-select>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <button class="btn btn-primary" [disabled]="!canOpen()" (click)="openPeriods()">
          <i class="fas fa-folder-open"></i> Abrir periodo {{monthLabel()}}
        </button>
        @if(!canOpen()) {
        <span class="text-muted ms-2"><i class="fas fa-circle-info"></i> Seleccione grupo</span>
        }
      </div>
    </div>
  </panel>

  <panel [title]="'Entidades — ' + monthLabel()" [noButton]="true">
    <div class="d-flex justify-content-end align-items-center mb-2">
      <div>
        <button class="btn btn-dark btn-sm me-1" [disabled]="selectedIds.size === 0" (click)="resetSelectedEntities()">
          <i class="fas fa-rotate"></i> Reiniciar desde 0
        </button>
        <button class="btn btn-info btn-sm me-1" [disabled]="selectedIds.size === 0" (click)="reopenSelected()">
          <i class="fas fa-rotate-left"></i> Reabrir seleccionados
        </button>
        <button class="btn btn-warning btn-sm me-1" [disabled]="selectedIds.size === 0" (click)="closeSelected()">
          <i class="fas fa-lock"></i> Cerrar seleccionados
        </button>
        <button class="btn btn-danger btn-sm" [disabled]="!hasOpen()" (click)="closeAllOpen()">
          <i class="fas fa-lock"></i> Cerrar todos
        </button>
      </div>
    </div>
    <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th style="width:36px;">
              <input type="checkbox" [checked]="isAllSelected()" [indeterminate]="isIndeterminate()" (change)="toggleAll()" />
            </th>
            <th>Entidad</th>
            <th>Estado</th>
            <th>Expiración</th>
            <th class="text-center">Puntaje</th>
            <th class="text-center">Nivel</th>
            <th class="text-center">Realizado</th>
            <th class="text-center">Firmado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for(p of periods; track p.id) {
          <tr>
            <td>
              <input type="checkbox" [checked]="selectedIds.has(p.id)" (change)="toggleSelection(p)" />
            </td>
            <td>{{p.entity?.code}} — {{p.entity?.name}}</td>
            <td><span class="badge {{statusBadge(p)}}">{{statusFor(p)}}</span></td>
            <td>
              @if(p.expiration) {
              {{p.expiration | date:'dd-MM-yyyy'}}
              } @else { - }
            </td>
            <td class="text-center">{{p.score ?? '-'}}
              @if(p.penaltyPercent > 0){
              <span class="badge bg-warning text-dark ms-1" title="Penalización aplicada por el auditor">-{{p.penaltyPercent}}%</span>
              }
            </td>
            <td class="text-center">{{p.level || '-'}}</td>
            <td class="text-center">
              @if(p.realized) {
              {{p.realizedUser?.displayName}}<br /><small>{{p.realized | date:'dd-MM-yyyy'}}</small>
              } @else { - }
            </td>
            <td class="text-center">
              @if(p.signedDate) {
              {{p.signedUser?.displayName}}<br /><small>{{p.signedDate | date:'dd-MM-yyyy'}}</small>
              } @else { - }
            </td>
            <td>
              @if(!p.noPeriod){
              <button class="btn btn-sm btn-outline-primary" (click)="editPeriod(p)" title="Editar vencimiento y puntaje"><i class="fas fa-pen"></i></button>
              }
              @if(!p.noPeriod && p.realized){
              <button class="btn btn-sm btn-outline-success ms-1" (click)="reviewPeriod(p)" title="Revisar periodo"><i class="fas fa-eye"></i></button>
              }
            </td>
          </tr>
          }
          @if(periods.length === 0) {
          <tr>
            <td colspan="9" class="text-center text-muted py-2 small">
              El grupo no tiene entidades asociadas
            </td>
          </tr>
          }
        </tbody>
      </table>
  </panel>
</div>
